/**
 * ClarityAnalytics — runs Microsoft Clarity across the WHOLE app, behind consent.
 *
 * 🔴 Scope is deliberately different from GA: GA measures only the auth funnel
 * (`AuthAnalytics`, guarded by `scope-grenze.test.ts`), Clarity records the
 * logged-in product too (decision 2026-09-19, plan
 * REQUIREMENTS/API/plan/2026-09-19_plan_01-microsoft-clarity-ganze-app-maskiert.md).
 * That is only acceptable because every rendered text is masked
 * (`data-clarity-mask` on `<body>` in index.html).
 *
 * Mounted as a saas.config `wrappers[]` entry: the kernel renders wrappers
 * inside `CookieConsentProvider` (so `useCookieConsent` works) but above the
 * router — which Clarity doesn't need, it follows SPA navigation on its own.
 * Safe no-op when Clarity is not configured (dev/staging have no id).
 */

import { useCookieConsent } from '@xhubio-saas/core-frontend/kernel'
import { useEffect } from 'react'
import { disableClarity, enableClarity } from './clarity'

export function ClarityAnalytics({ children }: { children: React.ReactNode }) {
  const { isAllowed } = useCookieConsent()
  const analyticsAllowed = isAllowed('analytics')

  // Load/revive on grant, stop + clear cookies on withdrawal. Nothing loads
  // before the user has granted the analytics category.
  useEffect(() => {
    if (analyticsAllowed) enableClarity()
    else disableClarity()
  }, [analyticsAllowed])

  return <>{children}</>
}
